import { type TranslationsContext } from '@ori/i18n';

import { defaultTranslations, translationsNamespace } from '../constants';
import { mainLogger } from '../logger';
import type { ClientAppConfig } from '../types';

export const getTranslationsProps = ({ currentLanguage, staticApiUrl, tenant, translations }: ClientAppConfig) => {
  const result: TranslationsContext = {
    clientFetchConfiguration: {
      baseUrl: staticApiUrl,
      onError: (error) => {
        mainLogger.error(error as Error, { action: 'Loading translations.' });
      },
      tenant,
    },
    currentLanguage,
    defaultTranslationsWithNamespaces: {
      [translationsNamespace]: defaultTranslations,
    },
    translationsWithNamespaces: translations ? { [translationsNamespace]: translations } : undefined,
  };

  return result;
};
